import { apiJson } from "../../../shared/lib/api-client.ts";
import type { ApiResponse } from "../../leaderboard/types/index.ts";
import type {
  DiscoveryStatusData,
  ReviewPendingResponse,
  ReviewStatsResponse,
} from "../types/index.ts";

export async function getDiscoveryStatus(): Promise<DiscoveryStatusData | null> {
  const payload = await apiJson<ApiResponse<DiscoveryStatusData>>("/v1/discovery/status");
  return payload.data ?? null;
}

export async function getReviewPending(params?: {
  limit?: number;
  offset?: number;
  search?: string;
  source?: string;
}): Promise<ReviewPendingResponse> {
  const qs = new URLSearchParams();
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.offset) qs.set("offset", String(params.offset));
  if (params?.search) qs.set("search", params.search);
  if (params?.source) qs.set("source", params.source);
  const payload = await apiJson<ApiResponse<ReviewPendingResponse>>(
    `/v1/discovery/review/pending?${qs.toString()}`
  );
  return payload.data!;
}

export async function getReviewStats(): Promise<ReviewStatsResponse> {
  const payload = await apiJson<ApiResponse<ReviewStatsResponse>>("/v1/discovery/review/stats");
  return payload.data!;
}

export async function approveProjects(projectIds: string[]): Promise<{ approved: number }> {
  const payload = await apiJson<ApiResponse<{ approved: number }>>("/v1/discovery/review/approve", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ projectIds }),
  });
  return payload.data!;
}

export async function approveAllProjects(source?: string): Promise<{ approved: number }> {
  const payload = await apiJson<ApiResponse<{ approved: number }>>(
    "/v1/discovery/review/approve-all",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(source ? { source } : {}),
    }
  );
  return payload.data!;
}

export interface RejectionEntry {
  projectId: string;
  reason: string;
  note?: string;
}

export async function rejectProjects(params: {
  rejections: RejectionEntry[];
}): Promise<{ rejected: number; filtered: number; stale: number }> {
  const payload = await apiJson<ApiResponse<{ rejected: number; filtered: number; stale: number }>>(
    "/v1/discovery/review/reject",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params),
    }
  );
  return payload.data!;
}
